import { Icon } from '@gumtree/ui-library';
import React from 'react';
import { StyledBodyItem } from './body-item.style';

type BodyItemProps = {
    label: string;
};

export const BodyItem = ({ label }: BodyItemProps) => {
    return (
        <StyledBodyItem>
            <Icon size="small" type="check" />
            <span>{label}</span>
        </StyledBodyItem>
    );
};
